/** These failures require a new reviewed choice, never a whole-slate Retry. */
export interface SuccessionDraftMutationState {
  readonly phase: 'idle' | 'saving' | 'saved' | 'unsaved';
  readonly error?: string;
  readonly conflictedTargetRefs?: readonly string[];
}

export function isSuccessionDraftConflict(error?: string): boolean {
  return Boolean(error && (['change_set_head_conflict', 'scenario_revision_conflict', 'graph_version_conflict',
    'graph_version_changed', 'source_version_conflict'].includes(error)
    || error.startsWith('The selected plan changed.') || error.startsWith('The plan changed since this edit.')));
}
